<template>
    <div class="container">
        <form @submit.prevent="createOrder" class="m-auto">
            <legend>Добавить заказ</legend>
            <div class="form-group row">
                <div class="col-lg-6">
                    <label class="required">Клиент</label>
                    <div>
                        <v-select v-model="customer" label="Reception" :filterable="false"
                                  :options="customers" @search="onSearch">
                            <template slot="no-options">
                                начните вводить приемный пункт...
                            </template>
                            <template slot="option" slot-scope="option">
                                <div class="d-center">
                                    {{ option.Reception }} ({{option['CustomerGroupName']}})
                                </div>
                            </template>
                            <template slot="selected-option" slot-scope="option">
                                <div class="selected d-center">
                                    {{ option.Reception }} ({{option['CustomerGroupName']}})
                                </div>
                            </template>
                            <template #search="{attributes, events}">
                                <input
                                        class="vs__search"
                                        :required="!customer"
                                        v-bind="attributes"
                                        v-on="events"
                                        v-on:keydown.enter.prevent
                                />
                            </template>
                        </v-select>
                    </div>
                </div>
                <div class="col-md-4 col-lg-2">
                    <label>Объезд</label>
                    <input type="text" class="form-control" readonly :value="tour.Name">
                </div>
                <div class="col-md-4 col-lg-2">
                    <label>Дни отправки</label>
                    <input type="text" class="form-control" readonly :value="dispatchDays">
                </div>
                <div class="col-md-4 col-lg-2">
                    <label class="required">Форма оплаты</label>
                    <v-select v-model="newOrder.PaymentType"
                              :disabled="!customer"
                              :options="paymentTypes"
                              label="Name">
                        <template #search="{attributes, events}">
                            <input
                                    class="vs__search"
                                    :required="!newOrder.PaymentType"
                                    v-bind="attributes"
                                    v-on="events"
                                    v-on:keydown.enter.prevent
                            />
                        </template>
                    </v-select>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-lg-6">
                    <label class="required">Артикул</label>
                    <div>
                        <v-select v-model="newOrder.Sku" label="Sku" :filterable="false"
                                  :disabled="!customer"
                                  :options="skus" @search="onSkuSearch">
                            <template slot="no-options">
                                начните вводить артикул...
                            </template>
                            <template slot="option" slot-scope="option">
                                <div class="d-center">
                                    {{ option.Sku }}
                                </div>
                            </template>
                            <template slot="selected-option" slot-scope="option">
                                <div class="selected d-center">
                                    {{ option.Sku }}
                                </div>
                            </template>
                            <template #search="{attributes, events}">
                                <input
                                        class="vs__search"
                                        :required="!newOrder.Sku"
                                        v-bind="attributes"
                                        v-on="events"
                                        v-on:keydown.enter.prevent
                                />
                            </template>
                        </v-select>
                    </div>
                </div>
                <div class="col-md-4 col-lg-2">
                    <label class="required">Цена</label>
                    <input type="number" class="form-control" v-model="newOrder.Price" required autocomplete="disable"
                           v-on:keydown.enter.prevent>
                </div>
                <div class="col-md-4 col-lg-2">
                    <label class="required">Количество</label>
                    <input type="number" class="form-control" v-model="newOrder.Amount" required min="1"
                           autocomplete="disable" v-on:keydown.enter.prevent>
                </div>
                <div class="col-md-4 col-lg-2">
                    <label class="required">Сумма за заказ</label>
                    <input type="number" class="form-control" v-model="newOrder.Summary" required readonly
                           autocomplete="disable" v-on:keydown.enter.prevent>
                </div>

            </div>
            <div class="form-group row" v-for="(dop, index) in newOrder.Dops">
                <div class="col-lg-6">
                    <label class="required">Название доп. работы</label>
                    <input type="text" class="form-control" v-model="dop.Name" required autocomplete="disable"
                           v-on:keydown.enter.prevent>
                </div>
                <div class="col-md-4 col-lg-2">
                    <label class="required">Цена</label>
                    <input type="number" class="form-control" v-model="dop.Price" required
                           autocomplete="disable" v-on:keydown.enter.prevent>
                </div>
                <div class="col-md-4 col-lg-4" style="padding-top: 2rem;">
                    <button class="btn btn-light btn-block" @click.prevent="delDop(index)">Удалить</button>
                </div>
            </div>
            <div class="form-group">
                <button class="btn btn-light" @click.prevent="addDop">Добавить дополнительную работу</button>
            </div>


            <div class="form-group row">
                <div class="col-md-6">
                    <label>Дата от клиента</label>
                    <div>
                        <date-picker class="w-100" v-model="newOrder.CustomerDate" valueType="format"
                                     :first-day-of-week="1" lang="ru"></date-picker>
                    </div>
                </div>
                <div class="col-md-3">
                    <label class="required">Принят</label>
                    <div>
                        <date-picker class="w-100" v-model="newOrder.ReceivedDate" valueType="format"
                                     :input-attr="{required: true}"
                                     :first-day-of-week="1" lang="ru"></date-picker>
                    </div>
                </div>
                <div class="col-md-3">
                    <label class="required">Дата готовности</label>
                    <div>
                        <date-picker class="w-100" v-model="newOrder.ReadyDate" valueType="format"
                                     :input-attr="{required: true}"
                                     :first-day-of-week="1" lang="ru"></date-picker>
                    </div>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-md-12 col-lg-6">
                    <label>Примечание</label>
                    <textarea name="" id="" cols="30" rows="3" v-model="newOrder.Comment"
                              class="form-control"></textarea>
                </div>
                <div class="col-md-6 col-lg-3">
                    <label>Номер клиента</label>
                    <input type="text" class="form-control" v-model="newOrder.LocalNumber" v-on:keydown.enter.prevent>
                </div>
                <div class="col-md-6 col-lg-3">
                    <label class="required">Номер сферы</label>
                    <input type="number" class="form-control" v-model="newOrder.SferaNumber" required
                           v-on:keydown.enter.prevent>
                </div>
            </div>
            <button class="btn btn-success" type="submit">Отправить</button>
        </form>
        <modals-container/>
        <v-dialog/>
    </div>
</template>
<script>
// https://www.npmjs.com/package/vue2-datepicker
import DatePicker from 'vue2-datepicker';
import _ from 'lodash';
import axios from 'axios';
import ErrorModal from '@/admin/components/ErrorModal.vue';
import { get, post } from '@/admin/services/api/http-utils';

const url = `${process.env.VUE_APP_API_HOST}admin/order-add-form`;

const DopBlank = {
  Name: '',
  Price: null,
};

const masterNewOrder = {
  CustomerDate: null,
  ReadyDate: null,
  CustomerId: null,
  PaymentTypeId: null,
  LocalNumber: null,
  SferaNumber: null,
  Price: null,
  Sku: null,
  Amount: 1,
  Summary: null,
  Comment: null,
  Dops: [],
};

export default {
  data() {
    return {
      customer: null,
      tour: {
        Name: null,
      },
      dispatchDays: null,

      newOrder: _.cloneDeep(masterNewOrder),
      customers: [],
      skus: [],
      paymentTypes: [],
    };
  },
  components: {
    DatePicker,
  },
  computed: {
    clientSDays() {
      if (!this.newOrder.Partner) {
        return '';
      }
      const SDays = {
        SDay1: 'ПН',
        SDay2: 'ВТ',
        SDay3: 'СР',
        SDay4: 'ЧТ',
        SDay5: 'ПТ',
      };
      const SDaysActive = [];
      _.forEach(SDays, (value, key) => {
        if (this.newOrder.Partner[key]) {
          SDaysActive.push(value);
        }
      });
      return SDaysActive.concat();
    },
  },
  watch: {
    customer: function handler(newVal) {
      this.updateTour();
      this.reloadDispatchDays();
    },
    'newOrder.Price': function handler(newVal) {
      let newValInt = parseInt(newVal, 10);
      if (!newValInt || isNaN(newValInt) || newValInt < 0) {
        newValInt = 0;
      }
      this.newOrder.Price = newValInt;
      this.calcSummary();
    },
    'newOrder.Amount': function handler(newVal) {
      let newValInt = parseInt(newVal, 10);
      if (!newValInt || isNaN(newValInt) || newValInt < 0) {
        newValInt = 1;
      }
      this.newOrder.Amount = newValInt;
      this.calcSummary();
    },
    'newOrder.Dops': {
      handler: async function handler() {
        this.calcSummary();
      },
      deep: true,
    },
    'customer.PaymentTypeId': function handler(newVal) {
      if (newVal) {
        const paymentType = _.findLast(this.paymentTypes, pt => Number(newVal) === Number(pt.Id));
        this.$set(this.newOrder, 'PaymentType', paymentType);
      }
    },
    'newOrder.Partner': function handler() {
      this.$set(this.newOrder, 'Sku', null);
      this.skus = [];
      this.$set(this.skus, []);
      this.reloadDispatchDays();
    },
    'newOrder.Sku': async function handler() {
      this.updatePrice();
    },
    'newOrder.PaymentType': async function handler() {
      this.updatePrice();
    },
  },
  async mounted() {
    const { data } = await axios.get(`${url}/payment-type`);
    this.paymentTypes = data.data;
  },
  methods: {
    async updateTour() {
      if (!this.customer) return;
      const { data } = await get(`${process.env.VUE_APP_API_HOST}admin/tour/${this.customer.TourId}`);
      this.tour = data;
    },
    async reloadDispatchDays() {
      console.log('reloadDispatchDays');
      this.dispatchDays = null;
      if (!this.customer) return;
      const { data } = await get(`${url}/dispatch-days/${this.customer.Id}`);
      this.dispatchDays = _.map(data, 'ShortName')
        .join(', ');
    },
    calcSummary() {
      let summary = Number(this.newOrder.Price) * Number(this.newOrder.Amount);
      _.each(this.newOrder.Dops, (value, index) => {
        summary += Number(value.Price);
      });
      this.newOrder.Summary = summary;
    },
    addDop() {
      this.newOrder.Dops.push(Object.assign({}, DopBlank));
      console.log(this.newOrder.Dops);
    },
    delDop(index) {
      if (!confirm('Удалить?')) return;
      this.newOrder.Dops.splice(index, 1);
    },
    createOrder() {
      const itemOptions = [];
      itemOptions.push({
        Name: `${this.newOrder.Sku.Sku} ${this.newOrder.Sku.Name}`,
        Price: this.newOrder.Price,
      }, ...this.newOrder.Dops);

      const orderItems = [];
      orderItems.push({
        itemOptions,
        ReceivedDate: this.newOrder.ReceivedDate,
        CustomerDate: this.newOrder.CustomerDate,
        ReadyDate: this.newOrder.ReadyDate,
        Comment: this.newOrder.Comment,
        SferaNumber: this.newOrder.SferaNumber,
        LocalNumber: this.newOrder.LocalNumber,
        CustomerId: this.customer.Id,
        PaymentTypeId: this.newOrder.PaymentType.Id,
        Summary: this.newOrder.Summary,
      });

      const order = {
        orderItems,
      };
      console.log(order);
      post(`${url}`, { order })
        .then((response) => {
          console.log(response);
          const orderItemSferaNumbers = response.data.map(currentValue => currentValue.SferaNumber);
          this.$modal.show('dialog', {
            title: 'Уведомление',
            text: `Заказ №${orderItemSferaNumbers.join(', ')} создан`,
            buttons: [
              {
                title: 'ОК',
              },
              {
                title: 'Очистить форму', // Button title
                default: true, // Will be triggered by default if 'Enter' pressed.
                handler: () => {
                  // this.clearOrderForm();
                  this.$modal.hide('dialog');
                }, // Button click handler
              },
            ],
          });
        })
        .catch((error) => {
          this.$modal.show(ErrorModal, {
            errors: error.response.data || [],
          }, {
            pivotY: 0.2,
          });
        });
    },
    clearOrderForm() {
      this.newOrder = _.cloneDeep(masterNewOrder);
    },
    async updatePrice() {
      console.log('updatePrice');
      this.$set(this.newOrder, 'Price', null);
      if (!this.newOrder.Sku || !this.newOrder.PaymentType) {
        this.$set(this.newOrder, 'Price', 0);
        return;
      }
      const { data } = await get(`${url}/get-price?SkuId=${this.newOrder.Sku.Id}&PaymentTypeId=${this.newOrder.PaymentType.Id}`);
      this.$set(this.newOrder, 'Price', data);
    },
    onSearch(search, loading) {
      if (!search) {
        return;
      }
      loading(true);
      this.search(loading, search, this);
    },
    search: _.debounce((loading, search, vm) => {
      get(`${url}/search-customers?q=${(search)}`)
        .then((res) => {
          vm.customers = res.data;
          loading(false);
        });
    }, 350),


    onSkuSearch(search, loading) {
      if (!search) {
        return;
      }
      loading(true);
      this.skuSearch(loading, search, this);
    },
    skuSearch: _.debounce((loading, search, vm) => {
      get(`${url}/search-sku?q=${search}&CustomerGroupId=${vm.customer.CustomerGroupId}`)
        .then((res) => {
          vm.skus = res.data;
          loading(false);
        });
    }, 350),
  },
};
</script>

<style lang="scss">
label.required {
    &::after {
        content: ' *';
        color: red;
    }
}
</style>
